/**
 * Easter egg: a signature in the browser console, for whoever opens the
 * developer tools — the back of the back.
 *
 * @module chrome/signature
 */

import { cssColor } from '../config.js';
import { pageEntry } from '../lib/page-data.js';

export function printSignature() {
    const paper = cssColor('bg', '#f4f1ea');
    const night = cssColor('night', '#0f1217');
    const red = cssColor('red', '#ea1d0f');
    const amber = cssColor('amber', '#ffb547');

    const front = `background:${paper};color:${red};font:800 16px/2 system-ui,sans-serif;padding:4px 10px;`;
    const back = `background:${night};color:${amber};font:800 16px/2 system-ui,sans-serif;padding:4px 10px;`;
    const text = `color:inherit;font:13px/1.6 ui-monospace,monospace;`;

    // The console is the only place this code talks.
    // eslint-disable-next-line no-console
    console.log(
        `%cFRONT%cBACK%c\n\nYou opened the back of the back.\n` +
            `Front vs Back, built by hand: Sass, ES modules, GSAP. The source maps are on —\n` +
            `the original modules are in the Sources panel.\n\n` +
            `Building something? ${pageEntry('chrome/signature').email}`,
        front,
        back,
        text,
    );
}
